export default __webpack_public_path__ + "static/media/img_step_1.1e3e782f.svg";